import React from "react";
import { motion } from "framer-motion";
import { CheckIcon } from "lucide-react";
import { TransformButton } from "./CtaButton";
interface Bonus {
  tag: string;
  emoji: string;
  title: string;
  body: string;
  includes: string[];
  value: string;
  image: string;
}
const bonuses: Bonus[] = [{
  tag: "Sistema Premium #1",
  emoji: "🔧",
  title: "Sistema Taller Productivo™",
  body: "Convierte cualquier espacio en un taller organizado que te permita terminar más reparaciones en menos tiempo.",
  includes: ["Método 5S adaptado a talleres", "Organización inteligente de herramientas", "Control de repuestos", "Flujo de trabajo recomendado", "Checklist diario de productividad"],
  value: "$37 USD",
  image: "https://cdn.magicpatterns.com/uploads/8jgj5YgezM43wJ3LtJhc4U/BONO_1_REPARACIONES.png"
}, {
  tag: "Sistema Premium #2",
  emoji: "💰",
  title: "Sistema Compras Inteligentes™",
  body: "Aprende a comprar repuestos como un técnico profesional y aumenta tus ganancias sin hacer una sola reparación adicional.",
  includes: ["Directorio de proveedores", "Comparador de precios", "Método de negociación", "Evaluación de proveedores", "Estrategia para compras inteligentes"],
  value: "$47 USD",
  image: "https://cdn.magicpatterns.com/uploads/m8iKMuFPJbtzgy6xgLZa7Y/BONO_2_REPARACIONES.png"
}, {
  tag: "Sistema Premium #3",
  emoji: "🛡️",
  title: "Sistema Garantía Blindada™",
  body: "Evita clientes problemáticos y protege tu reputación con un sistema de garantías profesional. Los conflictos aparecen cuando las condiciones no quedan claras.",
  includes: ["Formatos de garantía", "Condiciones de cobertura", "Protocolos de reclamos", "Guiones para comunicar garantías", "Casos prácticos"],
  value: "$47 USD",
  image: "https://cdn.magicpatterns.com/uploads/q9HVHyp6ruVyDWUCDtnTYS/BONO_3_REPARACIONES.png"
}, {
  tag: "Sistema Premium #4",
  emoji: "📈",
  title: "Sistema Ganancia Real™",
  body: "Descubre cuánto dinero estás perdiendo sin darte cuenta y aprende a calcular la utilidad real de cada reparación.",
  includes: ["Calculadora de costos", "Gastos ocultos", "Tiempo no facturado", "Costos operativos", "Utilidad real"],
  value: "$37 USD",
  image: "https://cdn.magicpatterns.com/uploads/agJTMbzcmCBbofBHfReJcw/BONO_4_REPARACIONES.png"
}, {
  tag: "Sistema Premium #5",
  emoji: "📲",
  title: "Sistema WhatsApp Vendedor™",
  body: "Haz que WhatsApp responda clientes, envíe cotizaciones y proyecte una imagen profesional incluso cuando estés trabajando.",
  includes: ["Mensajes automáticos", "Cotizaciones rápidas", "Catálogo optimizado", "Seguimiento de clientes", "Scripts de cierre"],
  value: "$67 USD",
  image: "https://cdn.magicpatterns.com/uploads/7Wdaw6PLx1kZxKGJVSY5WJ/BONO_5_REPARACIONES.png"
}];
export function BonusesSection() {
  return <section className="w-full bg-neutral-900 py-14" data-id="element-14" data-mp="1kji7atwsz4tx">
      <div className="mx-auto max-w-lg px-4" data-id="element-15" data-mp="1kl1msiamxbun">
        <div className="rounded-2xl border border-amber-400/30 bg-amber-400/[0.06] p-5 text-center" data-id="element-16" data-mp="15v41qb80529o">
          <p className="font-display text-lg font-extrabold leading-tight text-amber-300" data-id="element-17" data-mp="1asdrjrzazfy1">
            🎁 Hoy también recibirás estos 5 Sistemas Premium
          </p>
          <p className="mt-1 font-display text-2xl font-extrabold text-white" data-id="element-18" data-mp="10uzmspmqsflk">
            100% GRATIS
          </p>
          <p className="mt-3 text-sm leading-relaxed text-white/70" data-id="element-19" data-mp="mw019quj0gtm">
            Organizar un negocio no depende solo de tener documentos… depende de
            tener los sistemas correctos. Estos bonos te ayudan a implementarlo
            mucho más rápido.
          </p>
        </div>

        <div className="mt-6 space-y-5" data-id="element-20" data-mp="2m8c5a95feq5l">
          {bonuses.map((b, i) => <motion.article key={b.title} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: "-60px"
        }} transition={{
          duration: 0.4,
          delay: i * 0.03
        }} className="overflow-hidden rounded-2xl border border-white/10 bg-neutral-950" data-id="element-21" data-mp="2m683pxv0238h" data-mpi={i}>
              {b.image ? <div className="bg-white p-4" data-id="element-22" data-mp="37gul7qvyyj9">
                  <img src={b.image} alt={b.title} className="mx-auto h-52 w-auto object-contain" data-id="element-23" data-mp="388qyksb50al" />
                </div> : <div className="flex h-40 items-center justify-center bg-gradient-to-br from-neutral-800 to-neutral-950 text-6xl" data-id="element-24" data-mp="3pnbbl0xklff9">
                  {b.emoji}
                </div>}

              <div className="p-5" data-id="element-25" data-mp="3gllk5v3oughh">
                <span className="font-display text-[11px] font-bold uppercase tracking-widest text-amber-400" data-id="element-26" data-mp="3bnadft8owm3h">
                  🎁 {b.tag}
                </span>
                <h3 className="mt-1 font-display text-xl font-extrabold leading-tight text-white" data-id="element-27" data-mp="1r4zrxtzq2jym">
                  {b.emoji} {b.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-white/70" data-id="element-28" data-mp="2135ri4y23e0b">
                  {b.body}
                </p>

                <ul className="mt-4 space-y-2" data-id="element-29" data-mp="253pqzf63qtpm">
                  {b.includes.map(inc => <li key={inc} className="flex items-start gap-2.5 text-sm text-white/85" data-id="element-30" data-mp="18g1hflk3w9ho">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-amber-400" data-id="element-31" data-mp="1hfok0aoknlcb" />
                      {inc}
                    </li>)}
                </ul>

                <div className="mt-4 inline-flex items-center gap-2 rounded-lg bg-white/5 px-3 py-1.5" data-id="element-32" data-mp="1m7zmnlap5l8k">
                  <span className="text-xs font-semibold uppercase tracking-wide text-white/50" data-id="element-33" data-mp="tpu9w0vn0avr">
                    Valor comercial
                  </span>
                  <span className="font-display text-base font-extrabold text-amber-400 line-through decoration-red-500/70" data-id="element-34" data-mp="1wzgg7ww9qyyt">
                    {b.value}
                  </span>
                  <span className="font-display text-sm font-extrabold text-emerald-400" data-id="element-35" data-mp="26pj97x3e4cx5">
                    GRATIS
                  </span>
                </div>
              </div>
            </motion.article>)}
        </div>

        <div className="mt-8 flex justify-center" data-id="element-36" data-mp="1e25k2l5xolnl">
          <TransformButton label="Quiero los 5 bonos gratis" data-id="element-37" data-mp="193lwyhflt3tn" />
        </div>
      </div>
    </section>;
}